// ChallengesHubPage — Challenge pricing, scaling, reset, promotions, referrals

import { HubLayout } from './HubLayout';

export function ChallengesHubPage() {
  return (
    <HubLayout
      title="Challenges"
      testIdRoot="hub-challenges"
      hero={{
        title: 'Trade & earn',
        subtitle: 'Challenges, rewards, scaling',
        emoji: '🎯',
        gradient: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)',
        stats: [
          { label: 'Active',     value: '2',     sub: 'challenges' },
          { label: 'Funded',     value: '$100K', sub: 'Mid tier' },
          { label: 'Cumulative', value: '$5.3K', sub: 'paid out',   color: '#34C759' },
        ],
      }}
      quickActions={[
        { to: '/portal/challenge-pricing', label: 'Buy challenge', icon: '🛒', testId: 'hub-challenges-qa-buy' },
        { to: '/portal/scaling',           label: 'Scaling plan',  icon: '📈', testId: 'hub-challenges-qa-scaling' },
        { to: '/portal/reset-challenge',   label: 'Reset',         icon: '🔁', testId: 'hub-challenges-qa-reset' },
      ]}
      sections={[
        {
          title: 'Buy a Challenge',
          items: [
            { to: '/portal/challenge',        icon: '🎯', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Challenge entry',    sub: '4-step buying flow' },
            { to: '/portal/challenge-pricing', icon: '💰', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Challenge pricing', sub: 'Compare all 3 tiers · $79 / $149 / $219' },
            { to: '/portal/tier-compare',     icon: '📊', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Tier comparison',   sub: 'Side-by-side benefits' },
            { to: '/portal/tiers',             icon: '🗂️', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'All tiers',          sub: 'Browse all plans' },
            { to: '/portal/promotions',       icon: '🎟️', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Promotions & codes', sub: 'Gold offer · 50% off 2nd' },
          ],
        },
        {
          title: 'Manage Active Challenge',
          items: [
            { to: '/portal/scaling',          icon: '📈', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Scaling plan',        sub: 'Level 2 · $125K · next at $15K' },
            { to: '/portal/reset-challenge',  icon: '🔁', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Reset challenge',     sub: 'Anytime, keep days · $69/129/189' },
            { to: '/portal/challenge/active-1', icon: '🔍', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Active challenge',   sub: 'View single challenge' },
            { to: '/portal/dashboard',        icon: '📊', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'All challenges',      sub: '2 active · 1 in queue' },
          ],
        },
        {
          title: 'Earn More',
          items: [
            { to: '/portal/certificates',     icon: '🏆', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Certificates',         sub: '5 earned · funded + rewards' },
            { to: '/portal/referrals',        icon: '👥', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Referral program',     sub: '0/3 referrals · 1 mo free' },
            { to: '/portal/affiliate',        icon: '🔗', iconBg: 'linear-gradient(135deg, #5856D6 0%, #FF2D55 100%)', label: 'Affiliate',            sub: 'Custom referral code' },
          ],
        },
      ]}
    />
  );
}
